<template>
  <v-dialog v-model="dOpenComponente" persistent width="100%" height="100vh" content-class="">
    <v-card>
      <v-toolbar dark class="datModalTitleContainer">
        <v-toolbar-title>
          {{ pInformeComponente.nombre }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark @click="fCerrarVentana()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <iframe width="100%" height="700" :src="cLink" title="Query"></iframe>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ShpEQuery',
  props: {
    pInformeComponente: {
      type: Object,
      required: false
    },
    pLimitDate: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      tira: {},
      dOpenComponente: true
    }
  },
  mounted() {
    
  },
  methods: {
    fCerrarVentana() {
      this.$emit('close')
    },
  },
  computed: {
    cLink() {
      const json = {
        xDdolSecurityKey: "desarrollo",
        xDdolSecurityToken: this.tira,
        idDashboard: 808,
        modoFsal: 'S',
        empresa: this.$store.getters.getAutenticacion.empresa
      }
      const params = []
      
      params.push({
        param: 'idCliente',
        valor: 21352
      })

      json.params = params

      const jsonBase64 = btoa(JSON.stringify(json))

      return 'https://e-queryprep.expertxrm.com/expertQueryDashboard.html?login=' + jsonBase64
    }
  },
}

</script>


// WEBPACK FOOTER //
// src/components/ShpEQuery.vue